export interface LineOfBusiness {
	shortDesc: string;
	longDesc: string;
}

export interface ReportFilter {
	items: Array<{ reportFilterItemId: number }>;
	reportFilterId: number;
}

export class PickList {
	citizenship: PickListItem[];

	language: PickListItem[];

	maritalStatus: PickListItem[];

	race: PickListItem[];

	religion: PickListItem[];

	documentCategories: PickListItem[];

	prefix: PickListItem[];

	suffix: PickListItem[];

	contactRelationship: PickListItem[];

	contactTypes: PickListItem[];

	censusActionCode: PickListItem[];
}

export interface PickListItem {
	id: number;

	description: string;
}

export class PccFacility {
	orgId: number;

	orgUuid: string;

	facId: number;

	facilityName: string;

	country: string;

	addressLine1: string;

	postalCode: string;

	phone: string;

	fax: string;

	city: string;

	state: string;

	bedCount: number;

	lineOfBusiness: LineOfBusiness;

	healthType: string;

	facilityCode: string;

	orgName: string;

	environment: string;

	facilityStatus: string;

	countryId: number;

	timeZoneOffset: number;

	episodeOfCareEnabled: boolean;

	isTrackingHiePrivacyConsent: boolean;

	isUploadEnabled: boolean;

	isOmpiEnabled: boolean;

	orgDbType: string;

	billingStyleCountry: string;

	timeZone: string;

	active: boolean;

	headOffice: boolean;

	reportFilters: ReportFilter[];

	pickList: PickList;

	constructor(partial?: Partial<PccFacility>) {
		Object.assign(this, partial);
	}
}
